import React, {useState} from "react"
import Styles from "./rightContent.less"
import DiffSelect from "./select/selectDiff"
import DataList from "./dataList/dataList"
import {connect} from "react-redux"
import Loading from "./loading/loading"
import ErrorList from "./errorList/errorList"
import {ReducerState} from "../../../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../../../reducer/interface/controlInterface"
interface RightContentProps {
    comparisonStatus: ComparisonStatus
}
const RightContent: React.FunctionComponent<RightContentProps> = (props) => {
    const [num, setNum] = useState<number>(0)
    const [type, setType] = useState<string>("all")
    const renderStatus = () => {
        if (props.comparisonStatus.status === "waiting") {
            return <div className={Styles.waitingBox}>还没有接到比对任务，请先上传文档。</div>
        } else if (props.comparisonStatus.status === "loading") {
            return <Loading />
        } else if (props.comparisonStatus.status === "success") {
            return <DataList type={type} onSetNum={setNum} />
        } else if (props.comparisonStatus.status === "error") {
            return <ErrorList />
        }
    }
    return (
        <div className={Styles.contentBox}>
            <div
                style={{display: props.comparisonStatus.status !== "error" ? "flex" : "none"}}
                className={Styles.contentNav}
            >
                <div className={Styles.diffSelect}>
                    <DiffSelect num={num} handleChange={(optionType: string) => setType(optionType)} />
                </div>
            </div>
            <div className={Styles.contentBody}>{renderStatus()}</div>
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        comparisonStatus: state.control.comparisonStatus,
    }
})(RightContent)
